import { render, staticRenderFns } from "./DownloadPC.vue?vue&type=template&id=f41bb4fe&scoped=true"
import script from "./DownloadPC.vue?vue&type=script&lang=js"
export * from "./DownloadPC.vue?vue&type=script&lang=js"
import style0 from "./DownloadPC.vue?vue&type=style&index=0&id=f41bb4fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f41bb4fe",
  null
  
)

export default component.exports